import {ISearchType} from "./SearchPage";
import {UserSlider} from "../../components/blocks/TerracedGridTheme/StaffBlock/StaffBlock";
import React from "react";
import {ResultsHOC} from "./ResultsHOC";

export function UserResults(props: {
    searchTypes: ISearchType[],
    results?: {
        data: IUser[],
        meta: {
            total: number,
        }
    },
    isValidating: boolean,
    searchTerm: string,
}) {
    const total = props.results?.meta?.total || 0;
    return <ResultsHOC
        isLoading={props.results?.data === undefined}
        isValidating={props.isValidating}
        resultsCount={total}
        searchTypes={props.searchTypes}
        thisComponentType={"staff_members"}
        searchTerm={props.searchTerm}
        noResultsString={"staff members"}
    >
        <UserSlider users={props.results?.data || []}/>
    </ResultsHOC>
}